import { render, staticRenderFns } from "./personAfilStats.vue?vue&type=template&id=7744ffef&scoped=true&"
import script from "./personAfilStats.vue?vue&type=script&lang=js&"
export * from "./personAfilStats.vue?vue&type=script&lang=js&"
import style0 from "./personAfilStats.vue?vue&type=style&index=0&id=7744ffef&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7744ffef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7744ffef')) {
      api.createRecord('7744ffef', component.options)
    } else {
      api.reload('7744ffef', component.options)
    }
    module.hot.accept("./personAfilStats.vue?vue&type=template&id=7744ffef&scoped=true&", function () {
      api.rerender('7744ffef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/person-afil/personAfilStats.vue"
export default component.exports